module.exports = __webpack_public_path__ + "static/media/au.805aad61.svg";